
import React from 'react';
import { useDebug } from '@/hooks/use-debug';
import { Button } from '@/components/ui/button';
import { BugIcon } from 'lucide-react';

const DebugButton = () => {
  const { isDebugMode, toggleDebugMode } = useDebug();
  
  return (
    <Button
      variant="ghost"
      size="icon"
      className={`fixed bottom-4 right-4 opacity-50 hover:opacity-100 z-50 ${isDebugMode ? 'bg-red-200' : 'bg-transparent'}`}
      onClick={toggleDebugMode}
      title={isDebugMode ? 'Disabilita modalità debug' : 'Abilita modalità debug'}
    >
      <BugIcon size={18} className={isDebugMode ? 'text-red-600' : 'text-gray-500'} />
    </Button>
  );
};

export default DebugButton;
